export default __webpack_public_path__ + "static/media/Group 2134.5b647d1d.svg";